const CartItem = ({ item, onQuantityChange }) => (
  <div className="card mb-3 shadow-sm border-0 rounded-3">
    <div className="row g-0 align-items-center p-3">

      {/* Imagen */}
      <div className="col-md-2 text-center">
        <img
          src={item.Image}
          className="img-fluid rounded-3 shadow-sm"
          alt={item.name}
          style={{ maxHeight: "80px", objectFit: "contain" }}
        />
      </div>

      {/* Info producto */}
      <div className="col-md-4">
        <h6 className="fw-bold mb-1">{item.name}</h6>
        <p className="text-muted mb-0 small">{item.description}</p>
      </div>

      {/* Controles cantidad */}
      <div className="col-md-3 col-lg-3 col-xl-2 d-flex align-items-center justify-content-center gap-2">

        {/* Botón disminuir */}
        <button
          className="btn btn-light border fw-bold"
          style={{ width: "36px", height: "36px" }}
          onClick={() =>
            onQuantityChange(item.id, Math.max(0, item.cantidadEnCarrito - 1))
          }
          disabled={item.cantidadEnCarrito === 0}
        >
          −
        </button>

        {/* Cantidad */}
        <span
          className="fw-bold"
          style={{ minWidth: "24px", textAlign: "center" }}
        >
          {item.cantidadEnCarrito}
        </span>

        {/* Botón aumentar */}
        <button
          className="btn btn-success fw-bold"
          style={{ width: "36px", height: "36px" }}
          onClick={() =>
            onQuantityChange(item.id, item.cantidadEnCarrito + 1)
          }
        >
          +
        </button>

      </div>

      {/* Precio */}
      <div className="col-md-3 text-end">
        <h6 className="fw-bold text-primary mb-0">
          S/. {(item.price * item.cantidadEnCarrito).toFixed(2)}
        </h6>
      </div>

    </div>
  </div>
);

export default CartItem;

